/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { BadgeDirective } from "../../directives/badge.directive";

@Component({
	selector: "globalictcc-button",
	standalone: true,
	imports: [NgClass, MatButtonModule, BadgeDirective],
	templateUrl: "./button.component.html",
	styleUrl: "./button.component.scss"
})
export class ButtonComponent implements OnInit {
	@Input() public color: "primary" | "secondary" = "primary";
	@Input() public textOnly: boolean = false;
	@Input() public size: "small" | "large" = "large";
	@Input() public iconOnly: boolean = false;
	@Input() public iconPosition: "left" | "right" = "left";
	@Input() public iconName: string = "";
	@Input() public label: string = "";
	@Input() public hasBadge: boolean = false;
	@Input() public disabled: boolean = false;
	@Input() public type: "button" | "menu" | "reset" | "submit" = "button";

	@Output() public handleClick = new EventEmitter<void>();

	public buttonClass: string = "";

	ngOnInit() {
		this.buttonClass = `${this.textOnly ? "text-only" : this.color}`;
	}
}
